<!--Vuelidate error
    This component creates the error message block for Vuelidate
    
    HOW TO USE:
    
    <input :class="['form-field',{'form-field--invalid': v$.mentorData.title.$error}]"
           v-model="mentorData.title"
           @blur="v$.mentorData.title.$touch"/>
           
    <vuelidate-error type="required"
                     :name="$t('full_name', 'Full name')"
                     :model="v$.full_name"
    />
    
    PROPS:
        type:           Type of validation done on the field. Currently supported types are: required | url.
                        An array of types can be also used for field that have multiple validation rules. Example: :type="['required', 'url']"
        name:           Name of the field being validated. This should be translatable.
        model:          This is the validation object generated by vuelidate (v$.modelToBeValidated).
                        This is used to determine when errors are to be shown & the type of error (when multiple validation rules are in place)
-->

<template>
<div v-if="model.$error" class="paragraph-sm text-error mt-3 mb-0">{{ errorMessage }}</div>
</template>

<script>
import i18n from "src/i18n";

export default {
    name: "vuelidate-error",
    props: {
        type: {
            type: [String, Array],
            required: true
        },
        name: {
            type: String,
            default: i18n.global.t('validation.default_name')
        },
        model: {
            type: Object
        },
        message: {
            type: [String, Array],
        },
    },
    methods: {
        getErrorMsg(type) {
            let message;
            switch (type){
                case "required":
                    message = this.name + ' ' + i18n.global.t("validation.required");
                    break;
                case "url":
                    message = this.name + ' ' +  i18n.global.t("validation.url");
                    break;
                case "integer":
                    message = this.name + ' ' + i18n.global.t("validation.integer");
                    break;
                case "between":
                    message =
                        this.name + ' ' + i18n.global.t("validation.between") + " "
                        + this.model.between.$params.min + " & " + this.model.between.$params.max;
                    break;
                case "minLength":
                    message =
                        i18n.global.t("validation.too_short") + " "
                        + this.name + " " + i18n.global.t("validation.min_length") + " "
                        + this.model.minLength.$params.min + " " + i18n.global.t("validation.characters");
                    break;
                default:
                    message = this.name + ' ' + i18n.global.t("validation.invalid")
            }
            return message;
        }
    },
    computed: {
        errorMessage(){
            if( Array.isArray( this.type ) ) {
                let errors = [];
                this.type.forEach( validationType => {
                    if( this.model[ validationType ].$invalid ) {
                        let err = this.getErrorMsg( validationType );
                        if( validationType === 'required' && this.message ) {
                            err = this.message;
                        }
                        errors.push( err )
                    }
                } );
                return errors[0];
            } else {
                return this.message
                    ? this.message
                    : this.getErrorMsg( this.type );
            }
        }
    }
}
</script>
